import type { MeetingKind, MeetingThreadItem } from '@wundo/shared/meetingPage.ts';
import { m } from '@/paraglide/messages.js';

/**
 * What "always" covers. A 1:1 thread is a person, so it is named after them; a
 * team thread is the meeting over time. Without a thread yet — the one-off
 * meeting Wundo never followed — the classification is all there is to go on,
 * and naming the colleague we cannot name would be a guess.
 *
 * Shared, because every dialog that asks how far a choice reaches has to name
 * the far answer the same way: two copies would drift into two promises.
 */
export function meetingAlwaysLabel(
  thread: MeetingThreadItem | null,
  kind: MeetingKind,
): string {
  if (thread?.kind === 'one_on_one') {
    return m.meeting_scope_always_person({ name: thread.name });
  }
  if (!thread && kind === 'one_on_one') {
    return m.meeting_scope_always_colleague();
  }
  return m.meeting_scope_always_team();
}
